import React from 'react'
import FormComponent from "../components/formComponent";
import {renderReport} from "../components/elementList";

class UiGetField extends React.Component {

    static defaultProps = { };

    constructor(props) {
        super(props);

        this.fieldService = props.services.field;

        this.state = {
            fields: null,
        }
    }

    componentDidMount() {
        this.fieldService.getAssets().then(this.handleGetFieldsNext).catch(this.handleSubmitError);
    }

    handleGetFieldsNext = (response) => {
        this.setState({fields: response.data});
    };

    handleSelectFieldsNext = (response) => {

        let fieldObj = JSON.parse(response.FIELD);
        this.setState({field: fieldObj});
        this.props.finished(fieldObj);
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    renderAlert = (message, variant) => {
        this.setState({messageAlert: message, variantAlert: variant, showAlert: true});
    };

    renderSelectField = () => {
        let {fields} = this.state;
        let formElements = !!fields ? fields.map( field => {
            return  {value: JSON.stringify(field), label: field.name}
        }): null;

        let formElement = [{key: 'FIELD', type: 'select', inputType: 'select', placeholder: 'Select a Field',
            value: '', label: 'Field Area', options: formElements}];

        return (
            <div>
                {!!fields && <FormComponent
                    initialValues={{name: '', description: ''}}
                    validateFunc={() => {}}
                    submitFunc={this.handleSelectFieldsNext}
                    inputs={formElement}
                />}
            </div>
        );
    };

    reportField = () => {
        let { field } = this.state;
        if (!field) {
            return null;
        }
        let data = [
            { key: 'ID', value: field.id.id },
            { key: 'NAME', value: field.name },
            { key: 'TYPE', value: field.type }
        ];
        return data;
    };

    render() {
        let {field} = this.state;
        return (
            <div className="container-fluid">
                <div className="m-4 p-4">
                    {!field && this.renderSelectField()}
                    { renderReport( this.reportField() ) }
                </div>
            </div>);
    }
}

export default UiGetField;
